
import Lock from 'rde-view-common/components/common/lock/Lock';
import Header from 'rde-view-common/components/layouts/Header';

/**
 * フッタなしレイアウト
 */
export default {
  components: { Header, Lock }
};
